import { Image } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";
import { SPEEDGAUGE_SEGMENT_STOPS } from "../../../utils/weather/WeatherConstants";
import { DirectionCompass } from "../../common/direction-compass/DirectionCompass";
import compassBig from "../../common/images/compass_big.svg";
import compassSmall from "../../common/images/compass_small.svg";
import { SpeedGauge } from "../../common/speed-gauge/SpeedGauge";
import RunwayDetails from "./RunwayDetails";

export interface IRunwayWindCardProps {
  viewType: string;
  runwayWindDetails: any;
  orientation?: "vertical" | "horizontal";
  size?: "small" | "big";
  runwayImg?: string;
}

export const RunwayWindCard: React.FunctionComponent<IRunwayWindCardProps> = ({
  viewType,
  runwayWindDetails,
  runwayImg,
  orientation = "horizontal",
  size = "big",
}) => {
  const classes = useStyles();
  const activeRunway = runwayWindDetails?.runway?.split("_")[0];
  const headDegree =
    runwayWindDetails?.runwayEndData?.[activeRunway]?.heading ?? 0;
  const windComponents =
    runwayWindDetails?.runwayEndData?.[activeRunway]?.windComponents;
  return (
    <div
      className={`d-flex amd-container-vcolumn`}
      dir="ltr"
      data-testid="runway-windcard"
    >
      <div className={`${classes.runwayFlexRow} ${classes.mediaNoShrink}`}>
        <section className={classes.sectionDirection}>
          <div className=" text-uppercase fs-18">
            Wind Direction
            <span style={{ fontWeight: 600 }}>
              ({runwayWindDetails?.windInformation?.windDirection ?? 0}°)
            </span>
          </div>
          {runwayWindDetails?.runway ? (
            <div
              className={`${
                orientation === "horizontal"
                  ? `amd-container-vcenter ${
                      size === "small" ? "jc-spacebtwn" : "jc-start"
                    }`
                  : ""
              }`}
            >
              <DirectionCompass
                degree={runwayWindDetails?.windInformation?.windDirection ?? 0}
                headDegree={headDegree}
                canvasId={runwayWindDetails?.runway}
                size={size}
                runwayImg={runwayImg}
              />
              <div
                className={`wind-degree d-iblock fw-600 pl-1 ${
                  orientation === "vertical" ? "mt-2" : ""
                }`}
                style={{ fontSize: "26px" }}
              ></div>
            </div>
          ) : (
            <Image
              src={size === "big" ? compassBig : compassSmall}
              data-testid="compass-img"
            />
          )}
        </section>
        <section
          className={` ${classes.sectionRunway} ${
            viewType === "runway" ? "divider-v-grey" : ""
          }`}
        >
          <RunwayDetails
            headwind={windComponents?.headwind ?? 0}
            crosswind={windComponents?.crosswind?.value ?? 0}
            crosswindPercentage={windComponents?.crosswind?.percentage ?? 0}
            crosswindDirection={windComponents?.crosswind?.from}
            runwayImg={runwayImg}
            activeRunway={activeRunway}
          />
        </section>
        <section
          className={` ${classes.sectionSpeed} ${
            viewType === "runway" ? "divider-v-grey" : ""
          }`}
        >
          <div className="wind-speed text-uppercase fs-18 pl-2">Wind Speed</div>
          <div className="pt-1">
            <SpeedGauge
              speed={runwayWindDetails?.windInformation?.windSpeed ?? 0}
              minValue={0}
              maxValue={130}
              totalSegments={5}
              segmentStops={SPEEDGAUGE_SEGMENT_STOPS}
              viewType={viewType}
              gaugeWidth={size === "big" ? 300 : 200}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  runwayFlexRow: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexWrap: "nowrap",
    overflow: "hidden",
  },
  sectionDirection: {
    flex: "0 1 auto",
    width: "clamp(430px, 28vw, 440px)",
  },
  sectionRunway: {
    flex: "0 1 auto",
    minWidth: "clamp(300px, 30vw, 300px)",
    height: "350px",
  },
  sectionSpeed: {
    flex: "0 1 auto",
    width: "clamp(220px, 24vw, 420px)",
    height: "350px",
  },
  mediaNoShrink: {
    "& canvas, & img": {
      flexShrink: 0,
      maxWidth: "100%",
      height: "auto",
    },
  },
});
